import { useOnlineStatus } from "@/hooks/useOnlineStatus";
import { WifiOff } from "lucide-react";

export const OfflineBanner = () => {
  const isOnline = useOnlineStatus();

  if (isOnline) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-warning text-warning-foreground px-4 py-3 flex items-center justify-center gap-2 shadow-lg animate-in slide-in-from-bottom-5">
      <WifiOff className="w-4 h-4" />
      <span className="text-sm font-medium">
        You're offline. Your tasks will sync when you're back.
      </span>
    </div>
  );
};
